import * as SelectPrimitive from '@radix-ui/react-select';
import classNames from 'classnames';

import './select.scss';
import type { SelectProps } from './types';
import { DownIcon } from '../Icon';

export const Select = ({
  name,
  ariaLabel,
  label,
  variant = 'regular',
  invalid,
  withIcons,
  fullWidth,
  className,
  placeholder,
  borderless,
  disabled,
  value,
  options = [],
  onValueChange,
  defaultValue,
  defaultOpen,
  open,
  onOpenChange,
  'data-qe-id': dataQeId,
}: SelectProps) => {
  // Radix Select throws at runtime if we render an option with value="".
  // To make this issue does not happen, we filter out those options
  const safeOptions = options.filter((option) => option.value.trim() !== '');

  return (
    <div
      className={classNames(
        'payflow-ui select',
        borderless && 'borderless',
        withIcons && 'with-icons',
        fullWidth && 'fullwidth',
        invalid && 'has-error',
        `variant-${variant}`,
        className
      )}
    >
      {label && <label htmlFor={name}>{label}</label>}
      <SelectPrimitive.Root
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        defaultValue={defaultValue}
        defaultOpen={defaultOpen}
        open={open}
        onOpenChange={onOpenChange}
      >
        <SelectPrimitive.Trigger
          id={name}
          className="select__trigger"
          aria-label={ariaLabel ?? name}
          data-qe-id={dataQeId}
          name={name}
        >
          <SelectPrimitive.Value placeholder={placeholder} />
          <SelectPrimitive.Icon className="select__icon">
            <DownIcon />
          </SelectPrimitive.Icon>
        </SelectPrimitive.Trigger>
        <SelectPrimitive.Portal>
          <SelectPrimitive.Content
            position="popper"
            align="end"
            className={classNames('payflow-ui select__content', `variant-${variant}`)}
          >
            <SelectPrimitive.Viewport className="select__viewport">
              {safeOptions.map((option) => (
                <SelectPrimitive.Item
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                  className="select__option"
                >
                  {option.iconSrc ? (
                    <SelectPrimitive.ItemText>
                      <div className="select__option-with-icon">
                        <img src={option.iconSrc} alt={String(option.label)} />
                        {option.label}
                      </div>
                    </SelectPrimitive.ItemText>
                  ) : (
                    <SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText>
                  )}
                </SelectPrimitive.Item>
              ))}
            </SelectPrimitive.Viewport>
          </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
      </SelectPrimitive.Root>
    </div>
  );
};
